<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;    display: flex;
    justify-content: space-between;">
        <v-flex xm12 sm12 md12 lg8>
        </v-flex>


        <v-flex xs12 sm12 md12 lg3>
          <v-flex xs12 sm12 md12 lg10 style="display: flex; justify-content: center; padding-bottom: 27px;">
            <v-btn slot="activator" large class="white--text add_announcement text-xs-center"
                   @click="exportItinerary()">
               Export Itinerary List
            </v-btn>
          </v-flex>
        </v-flex>

      </v-layout>

      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :items="itinerary_list"
              item-key="id"
              :loading="loaders.itinerary_list_loader"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]">
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.start_stop_name }}
              </td>

              <td v-if="props.item.end_stop_name">
                {{ props.item.end_stop_name }}
              </td>
              <td v-else>{{ " - " }}</td>

              <td v-if="props.item.search_count">
                {{props.item.search_count}}
              </td>
              <td v-else>{{ " - "}}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                  :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn
            text
            dark
            @click="snackbar.display = false"
        >
          <v-icon
              right
              color="white"
          >
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Index",
  methods:{
    getList: function () {
      this.loaders.itinerary_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-itineraries`, {
            params: this.pagination
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.itinerary_list = response.data.data;
              this.loaders.itinerary_list_loader = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.display = true;
            this.snackbar.message = "Something went wrong";
          })
          .finally(() => {
            {
              this.loaders.itinerary_list_loader = false;
            }
          });

      this.is_loading = false;
    },
    download(type,data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download',
          'Itinerary_data_'+ moment().format('YYYY-MM-DD')
          + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportItinerary(){
      this.startLoading();
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/export-itinerary-data`, {
        headers: this.$headers,
        responseType: 'blob'
      }).then(
          (response) => {
            if (response.data) {
              this.stopLoading();
              this.download(this.exportType, response.data);
              this.exportType = '';

            } else if (response.data.status == 0) {
              this.stopLoading();
              this.snackbar.display = true;
              this.snackbar.message = response.data.message;
              this.exportType = '';
            }
          }
      ).catch((error) => {
        this.snackbar.display = true;
        this.snackbar.message = "Something went wrong";
        this.stopLoading();
        this.exportType = '';
      })
    }
  },
  data(){
    return{
      itinerary_list: [],
      pagination: {sortBy: "updated_at", descending: false, rowsPerPage: 10},
      headers: [
        {
          text: "Start Stop",
          value: "start_stop",
          align: "left",
          sortable: false,
        },
        {
          text: 'End Stop',
          value: 'end_stop',
          align: 'left',
          sortable: false
        },
        {
          text: "Search Count",
          value: "search_count",
          align: "left",
          sortable: false,
        }
      ],
      total_items: 0,
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      loaders: {
        itinerary_list_loader:false,
      },
      selected: [],
    }
  },
  mounted() {
    this.getList();
  }
}
</script>

<style scoped>

</style>
